import Script from 'next/script'

import { getConfig } from '@config/index'

const gtmConfig = getConfig().thirdPartyConfig.googleTagManager

const gtmCode = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
   new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
   j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
   'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
   })(window,document,'script', '${gtmConfig.layer}', '${gtmConfig.id}');`

export const GTMNoScriptIFrame = () => {
  return (
    <noscript>
      <iframe
        src={'//www.googletagmanager.com/ns.html?id=' + encodeURIComponent(gtmConfig.id)}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  )
}

export const GTMScript = () => {
  return (
    <Script
      id="gtm-setup"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: gtmCode }}
    />
  )
}
